module.exports = __webpack_public_path__ + "media/images/business/illust-case-06-d04b3fc44ae8d57d851a96a057d83d27.svg";